/**
 * Parses the site URL if provided, adding https if missing.
 *
 * @param {String} siteUrl the site's URL
 * @returns {String}
 */
export const parseSiteUrl = siteUrl => {
  if (!siteUrl) {
    return '';
  }

  if (siteUrl.indexOf('http') !== 0) {
    return `https://${siteUrl}`;
  }

  return siteUrl;
};
